import { render, staticRenderFns } from "./usersTrash.vue?vue&type=template&id=a8c234cc&scoped=true"
import script from "./usersTrash.vue?vue&type=script&lang=js"
export * from "./usersTrash.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8c234cc",
  null
  
)

export default component.exports